export default {
    accessibilityLabelButtonClose: 'Fermer',
};
